import React from 'react';
import EventCard from './EventCard';
import { EventCardSkeleton } from './EventGridSkeleton';
import { INFINITE_SCROLL_SENTINEL_AFTER_INDEX } from '../../constants/eventGrid';

const EventGrid = ({
  events,
  sentinelRef,
  hasMore = false,
  className = 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4',
  loadingMore = false
}) => (
  <>
    <div className={className}>
      {events.map((event, index) => (
        <React.Fragment key={event.id}>
          <EventCard event={event} />
          {sentinelRef &&
            hasMore &&
            index === INFINITE_SCROLL_SENTINEL_AFTER_INDEX &&
            events.length > INFINITE_SCROLL_SENTINEL_AFTER_INDEX && (
            <div
              ref={sentinelRef}
              className="col-span-full h-px w-full pointer-events-none opacity-0"
              aria-hidden
            />
          )}
        </React.Fragment>
      ))}
    </div>

    {loadingMore && (
      <div
        className={`${className} mt-4 opacity-80 pointer-events-none`}
        aria-hidden
      >
        {Array.from({ length: 5 }).map((_, i) => (
          <EventCardSkeleton key={i} />
        ))}
      </div>
    )}
  </>
);

export default EventGrid;
